import mapboxConfig from '@/config/mapbox';
import maptilerConfig from '@/config/maptiler';

/**
 * Builds static map preview URLs for Mapbox or MapTiler based on web_enableMapTiler.
 */
export function useMapStaticImage() {
  const testingStore = useTestingStore();
  const runtimeConfig = useRuntimeConfig();

  const getStaticMapImageUrl = ({
    longitude,
    latitude,
    zoom = 14,
    width = 300,
    height = 300,
    bearing = 0,
  }) => {
    const lng = Number(longitude);
    const lat = Number(latitude);

    if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
      return '';
    }

    if (testingStore.hasEnabledFeature('web_enableMapTiler')) {
      const apiKey = runtimeConfig.public.MAPTILER_API_KEY;
      const mapId = runtimeConfig.public.MAPTILER_STATIC_MAP_ID || maptilerConfig.staticMapId;

      if (!apiKey) {
        console.error('### MAPTILER_API_KEY is not configured');
        return '';
      }

      // MapTiler static maps only accept lon, lat, zoom — bearing is Mapbox-only.
      return `${maptilerConfig.staticImageApiBase}${mapId}/static/${lng},${lat},${zoom}/${width}x${height}.png?key=${apiKey}`;
    }

    return `${mapboxConfig.imageApiUrl}${lng},${lat},${zoom},${bearing}/${width}x${height}?access_token=${mapboxConfig.microsite.token}`;
  };

  return { getStaticMapImageUrl };
}
